/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { createPlantLogin } from '../../store/modules/user/actions';
import LoadingModal from '../../components/LoadingModal';

import './CreatePlantAdmin.scss';

const CreatePlantAdmin = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.user.isLoading);
  const {
    register, handleSubmit, reset, formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    dispatch(createPlantLogin(data, () => {
      reset();
    }));
  };

  return (
    <>
      <div className="add-mcc-rep create-plant-admin">
        <div className="row between">
          <div className="col-md-auto">
            <div className="heading">
              <p className="heading__title">
                Create Plant Login
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form">
              <div className="row">
                <div className="col-12 col-md-8 mx-auto">
                  <div className="row">
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="plateCode">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">Plant Code</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="text"
                                id="plateCode"
                                name="plateCode"
                                placeholder="Plant Code"
                                {...register('plateCode', {
                                  required: { value: true, message: 'Plant Code is required' },
                                })}
                              />
                              {errors.plateCode && <div className="form__error">{errors.plateCode.message}</div>}
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="plateName">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">Plant Name</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="text"
                                id="plateName"
                                name="plateName"
                                placeholder="Plant Name"
                                {...register('plateName', {
                                  required: { value: true, message: 'Plant Name is required' },
                                })}
                              />
                              {errors.plateName && <div className="form__error">{errors.plateName.message}</div>}
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="email">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">Email</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="email"
                                id="email"
                                name="email"
                                placeholder="Email"
                                {...register('email', {
                                  required: { value: true, message: 'Email is required' },
                                  pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: 'Invalid email address',
                                  },
                                })}
                              />
                              {errors.email && <div className="form__error">{errors.email.message}</div>}
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="password">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">Password</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="text"
                                id="password"
                                name="password"
                                placeholder="Password"
                                {...register('password', {
                                  required: { value: true, message: 'Password is required' },
                                })}
                              />
                              {errors.password && <div className="form__error">{errors.password.message}</div>}
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="regionName">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">Region Name</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="text"
                                id="regionName"
                                name="regionName"
                                placeholder="Region Name"
                                {...register('regionName', {
                                  required: { value: true, message: 'Region Name is required' },
                                })}
                              />
                              {errors.regionName && <div className="form__error">{errors.regionName.message}</div>}
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="regionCode">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">Region Code</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="text"
                                id="regionCode"
                                name="regionCode"
                                placeholder="Region Code"
                                {...register('regionCode', {
                                  required: { value: true, message: 'Region Code is required' },
                                })}
                              />
                              {errors.regionCode && <div className="form__error">{errors.regionCode.message}</div>}
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="clerkAbv">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">Clerk Abv</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="text"
                                id="clerkAbv"
                                name="clerkAbv"
                                placeholder="Clerk Abv"
                                {...register('clerkAbv', {
                                  required: { value: true, message: 'Clerk Abv is required' },
                                })}
                              />
                              {errors.clerkAbv && <div className="form__error">{errors.clerkAbv.message}</div>}
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="houseBank">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">House Bank</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="text"
                                id="houseBank"
                                name="houseBank"
                                placeholder="House Bank"
                                {...register('houseBank', {
                                  required: { value: true, message: 'House Bank is required' },
                                })}
                              />
                              {errors.houseBank && <div className="form__error">{errors.houseBank.message}</div>}
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="pinCode">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">Pincode (Optional)</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="text"
                                id="pinCode"
                                name="pinCode"
                                placeholder="Pincode"
                                {...register('pinCode')}
                              />
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form__item">
                        <label htmlFor="phone">
                          <div className="row middle">
                            <div className="col-12 col-md-4">
                              <span className="form__label">Phone (Optional)</span>
                            </div>
                            <div className="col-12 col-md-8">
                              <input
                                className="form__field"
                                type="text"
                                id="phone"
                                name="phone"
                                placeholder="Phone"
                                {...register('phone')}
                              />
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="col-12 text-center mt-3">
                  <div className="row">
                    <div className="col-12">
                      <div className="buttons">
                        <button type="button" className="button green" onClick={handleSubmit(onSubmit)}>Create Plant Login</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LoadingModal show={isLoading} />
    </>
  );
};

export default CreatePlantAdmin;
